import axios from 'axios';
import {V1API} from "../../../_helpers/APIPath";
import {encode, decode} from "../../dataMagic";
import {populateStore, performNetworkCall, buildFormData} from "@/store/asyncHelper";


const keyList = {
    smsUpdate : 'ANNUAL_REPORT_UPDATE',
    smsDelete : 'ANNUAL_REPORT_DELETE'
};

const mutations = {};
const store = {};

populateStore(store, mutations, keyList, false);

export default {
    namespaced: true,

    state : {
        
        annual_reports:[],
      
        report_detail:{},

        submitLoading: false,
        submitError: false,
        submitSuccess: false,

        reportLoading: false,
        reportError: false,

        
       
        ...store
    },

    mutations : {
        ...mutations,

        SET_ANNUAL_REPORT(state, law) {
            state.annual_reports = law;
        },

        SET_ANNUAL_REPORT_DETAIL(state, detail) {
            state.report_detail = detail;
        },

        SUBMIT_LOADING (state, loading) {
            state.submitLoading = loading;
        },
        SUBMIT_SUCCESS (state, success) {
            state.submitSuccess = success;
        },

        SUBMIT_ERROR (state, hasError) {
            state.submitError = hasError;
        },


        REPORT_LOADING (state, loading) {
            state.reportLoading = loading;
        },

        REPORT_ERROR (state, hasError) {
            state.reportError = hasError;
        },
        


       
    },

    actions: {
        //Report
        async addReport ({commit, dispatch}, payload) {
            commit('REPORT_LOADING', true);
            commit('REPORT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
                "Content-Type": "multipart/form-data"
            };

            try{
                let data2= new FormData()
                let payloadData = buildFormData(data2, payload.report);

                let response = await axios.post(V1API.create_annual_report, payloadData, config).then(result=>{
                    let data = result.data
                    return data

                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchReport')
               
                return response

            }catch (e) {
                commit('REPORT_ERROR', true);
            }finally {
                commit('REPORT_LOADING', false);
            }
        },

        async fetchReportDetail ({ commit },payload) {
            commit('REPORT_LOADING', true);
            commit('REPORT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try{
                let result = await axios.get(V1API.get_annual_report_details + payload, config);
                let response = result.data.data

                commit('SET_ANNUAL_REPORT_DETAIL', response);

            } catch(error) {
                commit('REPORT_ERROR', true);
            }
            finally {
                commit('REPORT_LOADING', false);
            }
        },



        async fetchReport ({ commit }) {
            commit('REPORT_LOADING', true);
            commit('REPORT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                  
                },
                
            };

            try{
                let result = await axios.get(V1API.annual_report_list, config);
                let response = result.data

                commit('SET_ANNUAL_REPORT', response.data);

            } catch(error) {
                commit('REPORT_ERROR', true);
            }
            finally {
                commit('REPORT_LOADING', false);
            }
        },


    
        async updateReport ({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
                 "Content-Type": "multipart/form-data"
            };

            try {
                let data2= new FormData()
                let payloadData = buildFormData(data2, payload.report);

                let response = await axios.patch(V1API.update_annual_report+payload.id,payloadData, config).then(result=>{
                    let data = result.data
                    return data

                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchReport')
                return response

            }catch (e) {
                commit('REPORT_ERROR', true);
            }finally {
                commit('REPORT_LOADING', false);
            }
        },

        
        async deleteReport({commit, dispatch}, payload) {
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            let response = await axios.delete(V1API.annual_report_delete + payload.delete, config).then(result=>{
                let data = result.data
                return data
            })
            
            dispatch ('fetchReport')
            
            return response
        },

    },

    getters: {}
}
